export const site = {
  title: 'Prism UI - React Demo',
  theme: '',
};
